export const LoadShortDate = (timeStampString) =>{
    const timeStamp = new Date(timeStampString);
    if(isNaN(timeStamp)) return 'invalid';
    let year = timeStamp.getFullYear();
    let month = timeStamp.getMonth() + 1;
    let date = timeStamp.getDate();
    return `${date >= 10 ? '':'0'}${date}-${month >= 10? '':'0'}${month}-${year}`;
}